// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal__BbCdLfxz2m{width:600px}.attributeDropdown__OBOVtKmd5d{flex-grow:1}`, "",{"version":3,"sources":["webpack://./src/components/contact/addContactAttributesModal/addContactAttributesModal.module.scss"],"names":[],"mappings":"AAAA,mBACE,WAAA,CAGF,+BACE,WAAA","sourcesContent":[".modal {\n  width: 600px;\n}\n\n.attributeDropdown {\n  flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal__BbCdLfxz2m`,
	"attributeDropdown": `attributeDropdown__OBOVtKmd5d`
};
export default ___CSS_LOADER_EXPORT___;
